export const securityQuestionEndpoints = (builder) => ({
    createSecurityQuestion: builder.mutation({
        query: (data) => ({url: `/security-question`, method: 'post', body: data}),
        invalidatesTags: ['Security Questions'],
    }),
    editSecurityQuestion: builder.mutation({
        query: (data) => ({ url: `/security-question/action`, method: 'patch', body: data }),
        invalidatesTags: ['Security Questions'],
    }),
    disableSecurityQuestion: builder.mutation({
        query: (data) => ({ url: `/security-question/action`, method: 'post', body: data }),
        invalidatesTags: ['Security Questions'],
    }),
    getUserSecurityQuestions: builder.query({
        query: ({ userId }) => ({ url: `/security-question/users/${userId}/random`, method: 'get' }),
        providesTags: ['Security Questions'],
    }),
    submitUserSecurityQuestionAnswers: builder.mutation({
        query: (data) => ({ url: `/security-question/users/answer`, method: 'post', body: data }),
        invalidatesTags: ['Security Questions'],
    }),
})
